<div class="container-fluid">
  <div class="row" style="height: 90vh">
    <!-- Item History Listing -->
    <div class="col-md-6 left-section">
      <h2 class="mb-3">Item History Listing</h2>
      <div class="row">
        <!-- Item 1 -->
        <div class="col-md-6 mb-2" *ngFor="let item of openItems">
          <div class="card mb-3 shadow-sm h-100">
            <div class="card-body d-flex flex-column">
              <div class="mb-2" (click)="selectOpenItem(item)">
                <h6 class="card-title mb-2">{{item.posItem.name}}</h6>
                <p class="card-text">RM {{item.price}}</p>
              </div>
              <div class="mt-auto d-flex justify-content-end">
                <button class="btn btn-sm btn-outline-success me-2 flex-shrink-1 text-truncate" (click)="addCart(item, $event)">
                  <i class="fa-solid fa-cart-shopping"></i> Cart
                </button>
                <button class="btn btn-sm btn-outline-primary me-2 flex-shrink-1 text-truncate" (click)="editItem(item, $event)">
                  <i class="fa-solid fa-pencil"></i> Edit
                </button>
                <button class="btn btn-sm btn-outline-danger flex-shrink-1 text-truncate" (click)="deleteItem(item, $event)">
                  <i class="fa-solid fa-trash"></i> Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side: Create New Open Item Form -->
    <div class="col-md-6 right-section">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="mb-0">{{title}}</h2>
        <button class="btn btn-danger" type="button" [disabled]="!isUpdate" (click)="newOpenItem()">
          <i class="fa fa-check-circle me-2"></i>
          New Open Item
        </button>
      </div>

      <mat-dialog-content class="flex-grow-1 d-flex flex-column">
        <form [formGroup]="openItemForm" class="flex-grow-1 d-flex flex-column justify-content-between">
          <!-- Form fields -->
          <div class="form-group mb-3">
            <label for="itemName">Item Name</label>
            <input type="text" class="form-control" id="itemName" formControlName="itemName" placeholder="Enter item name">
            <div *ngIf="openItemForm.get('itemName').invalid && openItemForm.get('itemName').touched" class="text-danger">
              <small>Item Name is required and must be at least 3 characters long.</small>
            </div>
          </div>
          <div class="form-group mb-3">
            <label for="itemPrice">Item Price</label>
            <input type="text" class="form-control" id="itemPrice" formControlName="itemPrice" placeholder="Enter item price">
            <div *ngIf="openItemForm.get('itemPrice').invalid && openItemForm.get('itemPrice').touched" class="text-danger">
              <small>Item Price is required and must be a valid price format.</small>
            </div>
          </div>

          <div class="form-group mb-3">
            <label for="itemPrice">Kitchen</label> <br>
            <select class="form-control" id="inlineFormCustomSelect" formControlName="itemKitchen">
              <option selected>Choose...</option>
              <ng-container *ngFor="let k of kitchen">
                <option [value]="k.key" >{{k?.value | titlecase}}</option>
              </ng-container>
            </select>
            <div *ngIf="openItemForm.get('itemKitchen').invalid && openItemForm.get('itemKitchen').touched" class="text-danger">
              <small>Kitchen is required.</small>
            </div>
          </div>

          <!-- Form actions -->
          <mat-dialog-actions class="mt-auto">
            <hr>
            <div class="d-flex justify-content-center">
              <button class="btn btn-secondary me-3" type="button" (click)="cancelOpenItem($event)">
                <i class="fa fa-times-circle me-2"></i>
                Cancel
              </button>
              <button class="btn btn-success me-3" type="button" [disabled]="openItemForm.invalid" (click)="saveOpenItem()">
                <i class="fa fa-check-circle me-2"></i>
                {{saveButton}}
              </button>
              <button class="btn btn-primary" type="submit" [disabled]="openItemForm.invalid" (click)="onSubmit()">
                <i class="fa fa-check-circle me-2"></i>
                {{submitButton}}
              </button>
            </div>
          </mat-dialog-actions>
        </form>
      </mat-dialog-content>
    </div>
  </div>
</div>
